"use client"
import React, { useState, useEffect, useCallback } from "react"
import * as classes from "./team.module.scss"
import { useBreakpoint } from "../../../hooks/breakpoints"
import SlideWrapper from "@/components/Shared/SlideWrapper/slideWrapper"
// import Carousel from "nuka-carousel"
import { Carousel } from "nuka-carousel"
// import Carousel from "nuka-carousel"
import { Arrow } from "../../../../public/icons/icon-components/arrow-forward"
import { cn } from "@/utils/cn"
import useEmblaCarousel from 'embla-carousel-react';
import { TeamMemberItem } from "./TeamMember";



const Team = ({ teamMembers, theme }) => {
	// console.log('teamMembers', teamMembers)
	const [emblaRef, emblaApi] = useEmblaCarousel({
		axis: 'x',
		dragFree: true,
		slidesToScroll: 1,
		skipSnaps: true,
		containScroll: 'trimSnaps',
	});

	const [canPrev, setCanPrev] = useState(false);
	const [canNext, setCanNext] = useState(false);

	/* обновляем состояние стрелок при каждом выборе */
	const onSelect = useCallback(() => {
		if (!emblaApi) return;
		setCanPrev(emblaApi.canScrollPrev());
		setCanNext(emblaApi.canScrollNext());
	}, [emblaApi]);

	useEffect(() => {
		if (!emblaApi) return;
		onSelect();                     // инициализация
		emblaApi.on('select', onSelect);
		emblaApi.on('reInit', onSelect);
	}, [emblaApi, onSelect]);
	const showArrows = canPrev || canNext

	return (
		<div className="w-full" >
			<div className="flex justify-between items-center pb-[30px] xl:pb-12">
				<p
					className="xl:text-[34px] xl:leading-[100%] font-medium text-[24px] leading-[100%]"
					style={{
						fontFamily: theme?.fontFamilyPrimary,
						color: theme?.primaryFontColor,
					}}
				>
					The Team:
				</p>
				{showArrows && (
					<div className="flex gap-4">
						<button
							disabled={!canPrev}
							onClick={() => emblaApi?.scrollPrev()}
							name="previous"
							className="disabled:opacity-40 cursor-pointer disabled:cursor-default "
						>
							<Arrow color={theme.primaryFontColor} />
						</button>
						<button
							disabled={!canNext}
							onClick={() => emblaApi?.scrollNext()}
							name="next"
							className="disabled:opacity-40 cursor-pointer disabled:cursor-default"
						>
							<Arrow
								color={theme.primaryFontColor}
								style={{ transform: 'rotate(-180deg)' }}
							/>
						</button>
					</div>
				)}
			</div>
			{/* <SlideWrapper triggerOnce direction={"up"} > */}

			<div className="flex justify-center min-w-full">
				<div className={cn("overflow-hidden select-none ",)} >
					{/* <div className={cn("overflow-hidden select-none mx-auto",)} > */}


					{/* <div className={cn("overflow-hidden select-none min-w-full", showArrows ? 'block' : 'justify-center flex items-center ')} > */}
					{/* <div className="overflow-hidden cursor-grab  flex items-center justify-center select-none min-w-full" > */}

					<div className="cursor-grab" ref={emblaRef}>
						<div className="flex gap-5 xl:gap-6 ">
							{teamMembers.map((item, index) => (
								// {teamMembers.slice(0,1).map((item, index) => (
								<TeamMemberItem key={index} {...item} theme={theme} />
							))}
						</div>
					</div>
				</div>
			</div>
			{/* </SlideWrapper> */}
		</div>

	)
}
// const Team = ({ teamMembers, theme }) => {
// 	const [value, setValue] = useState(0)
// 	const [active, setActive] = useState(true)
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(6)

// 	useEffect(() => {
// 		if (breakpoint.sm || breakpoint.xs) {
// 			setSlideToShow(1)
// 			teamMembers?.length > 1 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.md) {
// 			setSlideToShow(2)
// 			teamMembers?.length > 2 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.l) {
// 			setSlideToShow(3)
// 			teamMembers?.length > 3 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.xl) {
// 			setSlideToShow(3)
// 			teamMembers?.length > 3 ? setActive(true) : setActive(false)
// 		} else {
// 			teamMembers?.length > 3 ? setActive(true) : setActive(false)
// 			setSlideToShow(3)
// 		}
// 	}, [breakpoint, slideToShow])

// 	return (
// 		<>
// 			<div className={classes["teamWrapper"]}>
// 				<div className={classes["teamInnerWrapper"]}>
// 					<div
// 						className={classes["title"]}
// 						style={{
// 							fontFamily: theme?.fontFamilyPrimary,
// 							color: theme?.primaryFontColor,
// 						}}
// 					>
// 						The Team
// 					</div>
// 					{active && (
// 						<div className={classes["arrowIcons"]}>
// 							<button
// 								onClick={() =>
// 									setValue(prev =>
// 										prev <= 0 ? teamMembers?.length - 1 : prev - 1
// 									)
// 								}
// 								style={{
// 									border: "none",
// 									background: "transparent",
// 									cursor: "pointer",
// 								}}
// 							>
// 								<Arrow color={theme.primaryFontColor} />
// 							</button>
// 							<button
// 								onClick={() =>
// 									setValue(prev =>
// 										prev === teamMembers?.length - 1 ? 0 : prev + 1
// 									)
// 								}
// 								style={{
// 									border: "none",
// 									background: "transparent",
// 									cursor: "pointer",
// 								}}
// 							>
// 								<Arrow
// 									color={theme.primaryFontColor}
// 									style={{
// 										transform: "rotate(-180deg)",
// 									}}
// 								/>
// 							</button>
// 						</div>
// 					)}
// 				</div>
// 				{/* <div>
// 					<Carousel
// 						slidesToShow={slideToShow}
// 						slideIndex={value}
// 						framePadding="0px 10px "
// 						renderBottomCenterControls={false}
// 						renderCenterLeftControls={false}
// 						renderCenterRightControls={false}
// 					>
// 						{teamMembers.map((item, index) => (
// 							<SlideWrapper triggerOnce direction={"up"} key={index}>
// 								<div className={classes["profileTab"]}>
// 									<div className={classes["profilePic"]}>
// 										{
// 											<img
// 												src={
// 													item.teamMemberImageUrl
// 														? item.teamMemberImageUrl
// 														: "/icons/person.svg"
// 												}
// 												alt="profile pic"
// 											/>
// 										}
// 									</div>

// 									<div className={classes["profileDetail"]}>
// 										<div>
// 											<h3
// 												className={classes["profileName"]}
// 												style={{
// 													color: theme.primaryFontColor,
// 													fontFamily: theme.fontFamilyPrimary,
// 												}}
// 											>
// 												{item.firstName + " " + item.lastName}
// 											</h3>
// 											<p
// 												className={classes["profilePosition"]}
// 												style={{
// 													color: theme.secondaryFontColor,
// 													fontFamily: theme.fontFamilySecondary,
// 												}}
// 											>
// 												{item.role}
// 											</p>
// 										</div>
// 										{item.linkedInProfileUrl && (
// 											<div
// 												className={classes["profileLink"]}
// 												style={{
// 													borderColor: theme.primaryFontColor,
// 												}}
// 											>
// 												<a
// 													href={item.linkedInProfileUrl}
// 													target="_blank"
// 													rel="noreferrer"
// 													style={{
// 														fontFamily: theme.fontFamilySecondary,
// 														color: theme.primaryFontColor,
// 													}}
// 												>
// 													LinkedIn
// 												</a>
// 											</div>
// 										)}
// 									</div>
// 								</div>
// 							</SlideWrapper>
// 						))}
// 					</Carousel>
// 				</div> */}
// 			</div>
// 		</>
// 	)
// }

export default Team
